import React from "react";
import { useParams } from "react-router-dom";
import { getScorerLeagueTable } from '../../../api/getScorerLeagueTable';

import styles from "./LeagueGoalsKingTable.module.css";

function LeagueGoalsKingTable() {
  const { leagueId } = useParams();
  const [scores, setScores] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    getScorerLeagueTable(leagueId).then((data) => {
      setScores(data);
      setIsLoading(false);
    });
  }, [leagueId]);

  return (
    <div className={styles.leagueGoalsTable}>
      <div className="collapsBtn">מלכי השערים</div>
      <div className={`${styles.tableRow} ${styles.tableTopic}`}>
        <div>-</div>
        <div>שחקן</div>
        <div>קבוצה</div>
        <div>שערים</div>
      </div>

      {isLoading ? (
        <div>הנתונים בטעינה ...</div>
      ) : (
        scores.map((score, index) => (
          <div
            key={score.user_id}
            className={`${styles.tableRow} ${
              index % 2 === 0 ? styles.odd : styles.even
            }`}
          >
            <div>{index + 1}</div>
            <div>{score.full_name}</div>
            <div>{score.team_name}</div>
            <div>{score.goals_count}</div>
          </div>
        ))
      )}
    </div>
  );
}

export default LeagueGoalsKingTable;
